import React from 'react';
import { useAdjudicationStore } from '../store/adjudicationStore';
import { CheckCircle, XCircle, AlertTriangle } from 'lucide-react';

export const AdjudicationResults: React.FC = () => {
  const { adjudicationResults } = useAdjudicationStore();

  if (!adjudicationResults || adjudicationResults.length === 0) {
    return (
      <div className="p-4 text-slate-400 text-center">
        No results to display yet.
      </div>
    );
  }

  return (
    <div className="bg-slate-900/95 border border-slate-700 rounded-lg p-6 max-w-2xl mx-auto mt-10 shadow-2xl">
      <h2 className="text-2xl font-bold text-slate-100 mb-6 flex items-center gap-3">
        <span className="text-blue-400">Turn Results</span>
        <span className="text-sm font-normal text-slate-500 ml-auto">
          {adjudicationResults.length} Actions Processed
        </span>
      </h2>

      <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
        {adjudicationResults.map((result) => (
          <div 
            key={result.actionId}
            className={`p-4 rounded-lg border ${
              result.success 
                ? 'bg-slate-800/50 border-slate-700' 
                : 'bg-red-900/20 border-red-800/50'
            }`}
          >
            <div className="flex items-start gap-3">
              {result.success ? (
                <CheckCircle className="w-5 h-5 text-green-400 mt-0.5 shrink-0" />
              ) : (
                <XCircle className="w-5 h-5 text-red-400 mt-0.5 shrink-0" />
              )}
              
              <div className="flex-1">
                <div className="flex justify-between items-start mb-1">
                  <h4 className={`font-medium ${result.success ? 'text-slate-200' : 'text-red-200'}`}>
                    {result.message}
                  </h4>
                  <span className="text-xs font-mono text-slate-500 bg-slate-800 px-2 py-1 rounded">
                    Cost: {result.cost}
                  </span>
                </div>
                
                {result.stateChanges && result.stateChanges.length > 0 && (
                  <div className="mt-2 text-sm text-slate-400 pl-2 border-l-2 border-slate-700">
                    {result.stateChanges.map((change, idx) => (
                      <div key={idx} className="flex items-center gap-2">
                        <span className="w-1 h-1 bg-blue-500 rounded-full" />
                        {change}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
